// extracted by mini-css-extract-plugin
export default {"buttonSpan":"alertsGroup_buttonSpan__0iudc"};